<template>

    <main
            class="article"
            v-bind:class="{
                'headerIsDisabled' : post['acf']['config_disable_header'],
                'teaserIsDisabled' : post['acf']['config_disable_teaser'],
                'featuresIsDisabled' : post['acf']['config_disable_features'],
                'isEmpty' : isEmpty
            }"
            v-bind:data-content-class="this.post['acf']['content_class']"
    >

        <div class="article-inner" v-if="isLoaded">

            <template v-if="post['acf']['config_disable_header'] !== true">
                <template v-if="post['acf']['teaser_video_youtube_id']">
                    <div
                            class="article-hero-video"
                            v-bind:data-log="post['acf']['teaser_video_youtube_id']"
                            v-if="isRendered"
                    >
                        <div class="youtube-wrap">
                            <iframe
                                    width="640"
                                    height="360"
                                    frameborder="0"
                                    :src="'https://www.youtube.com/embed/' + post['acf']['teaser_video_youtube_id'] + '?hl=de&modestbranding=1&rel=0&showinfo=0'"
                            ></iframe>
                        </div>
                        <!--
                        <vue-plyr>
                            <div
                                    :data-plyr-embed-id="post['acf']['teaser_video_youtube_id']"
                                    data-plyr-provider="youtube"
                            ></div>
                        </vue-plyr>
                        //-->
                        <!--
                        <youtube
                                :video-id="post['acf']['teaser_video_youtube_id']"
                                :player-vars="{ modestbranding : 1, rel : 0, showinfo : 0 }"
                                :player-width="'100%'"
                        ></youtube>
                        //-->
                    </div>
                </template>
                <template v-else>
                    <template v-if="post['acf']['teaser_image_3840_1536']">
                        <div class="article-hero-container">
                          <div
                                  class="article-hero"
                                  v-bind:style="{ backgroundImage : 'url(' + headerImage() + ')' }"
                          >
                              <div class="overlay"></div>
                              <div
                                      class="article-hero-caption"
                                      v-bind:class="{ 'article-hero-caption-right' : post['acf']['teaser_headline_position'] === 'right' }"
                              >
                                  <component
                                          :is="post['acf']['teaser_headline_tag'] || 'p'"
                                          class="content-headline"
                                          v-html="post['acf']['teaser_headline']"
                                          v-if="post['acf']['teaser_headline']"
                                          v-bind:class="{
                                              'content-headline-black' : post['acf']['teaser_headline_color'] === 'black',
                                              'content-headline-pink' : post['acf']['teaser_headline_color'] === 'red',
                                              'content-headline-white' : post['acf']['teaser_headline_color'] === 'white',
                                              'content-headline-none' : post['acf']['teaser_headline_color'] === 'none'
                                          }"
                                  ></component>
                              </div>
                          </div>
                          <div class="image-copyright-text" v-if="post['acf']['teaser_image_copyright_text']" v-html="'&copy; ' + post['acf']['teaser_image_copyright_text']"></div>
                        </div>
                    </template>
                </template>
            </template>

            <div
                    class="article-content"
                    v-bind:class="{ 'isEmpty' : isEmpty }"
            >
                <template v-for="(content, contentIndex) in post['acf']['content_composer']">

                    <h1
                            class="content-headline"
                            v-if="content['acf_fc_layout'] === 'content_composer_headline_h1'"
                    >
                        {{ content['content_headline_h1'] }}
                    </h1>

                    <h2
                            class="content-subline"
                            v-if="content['acf_fc_layout'] === 'content_composer_subline_h2'"
                    >
                        {{ content['content_subline_h2'] }}
                    </h2>

                    <h3
                            class="content-subline"
                            v-if="content['acf_fc_layout'] === 'content_composer_subline_h3'"
                    >
                        {{ content['content_subline_h3'] }}
                    </h3>

                    <div
                            class="content-copy-body"
                            v-bind:class="{
                                'isFirstOfLayout' : wpApi.indexOfFirstACFFlexibleContentLayout(post['acf']['content_composer'], 'content_composer_copy_body') === contentIndex,
                                'isLastOfLayout' : wpApi.indexOfLastACFFlexibleContentLayout(post['acf']['content_composer'], 'content_composer_copy_body') === contentIndex
                            }"
                            v-html="content['content_copy_body']"
                            v-if="content['acf_fc_layout'] === 'content_composer_copy_body'"
                    ></div>

                    <div
                            class="content-footnotes"
                            v-html="content['content_footnotes']"
                            v-if="content['acf_fc_layout'] === 'content_composer_footnotes'"
                    ></div>

                    <template v-if="content['acf_fc_layout'] === 'content_composer_featured_person'">
                        <div class="article-featured-person">
                            <div
                                    class="content-featured-person-image"
                                    v-bind:style="{ backgroundImage : 'url(' + content['content_featured_person_image_512_512'] + ')' }"
                            ></div>
                            <div class="article-featured-person-details">
                                <h4 class="content-featured-person-name">
                                    {{ content['content_featured_person_name'] }}
                                </h4>
                                <div
                                        class="content-featured-person-info"
                                        v-html="content['content_featured_person_info']"
                                ></div>
                            </div>
                        </div>
                    </template>

                    <address
                            class="article-address"
                            v-html="content['content_address']"
                            v-if="content['acf_fc_layout'] === 'content_composer_address'"
                    ></address>

                    <template v-if="content['acf_fc_layout'] === 'content_composer_video'">
                        <div
                                class="article-video"
                                v-bind:data-log="content['content_video_youtube_id']"
                                v-if="isRendered"
                        >
                            <div class="youtube-wrap">
                                <iframe
                                        width="640"
                                        height="360"
                                        frameborder="0"
                                        class="optanon-category-C0004"
                                        :src="'https://www.youtube.com/embed/' + content['content_video_youtube_id'] + '?hl=de&modestbranding=1&rel=0&showinfo=0'"
                                        :data-src="'https://www.youtube.com/embed/' + content['content_video_youtube_id'] + '?hl=de&modestbranding=1&rel=0&showinfo=0'"
                                ></iframe>
                            </div>
                            <!--
                            <vue-plyr>
                                <div
                                        :data-plyr-embed-id="content['content_video_youtube_id']"
                                        data-plyr-provider="youtube"
                                ></div>
                            </vue-plyr>
                            //-->
                            <!--
                            <youtube
                                    :video-id="content['content_video_youtube_id']"
                                    :player-vars="{ modestbranding : 1, rel : 0, showinfo : 0 }"
                                    :player-width="'100%'"
                            ></youtube>
                            //-->
                        </div>
                        <h1
                                class="content-video-title"
                                v-if="content['content_video_title']"
                        >
                            {{ content['content_video_title'] }}
                        </h1>
                        <div
                                class="content-video-summary"
                                v-html="content['content_video_summary']"
                                v-if="content['content_video_summary']"
                        ></div>
                    </template>

                    <template v-if="content['acf_fc_layout'] === 'content_composer_new_video'">
                        <content-new-video
                                :title="content['content_new_video_title']"
                                :description="content['content_new_video_description']"
                                :file="content['content_new_video_file']"
                                :thumbnail="content['content_new_thumbnail_file']"
                                :layout="content['content_new_video_layout']"
                        ></content-new-video>
                    </template>

                    <div
                        class="content-image-container"
                        v-if="content['acf_fc_layout'] === 'content_composer_image' && content['content_image_1440_1080']"
                    >
                            <div class="content-image">
                                <img
                                        v-bind:alt="content['content_image_alt_text']"
                                        v-bind:src="content['content_image_1440_1080']"
                                >
                          </div>
                        <div class="image-copyright-text"
                           v-if="content['content_image_copyright_text']"
                           v-html="'&copy; ' + content['content_image_copyright_text']"></div>
                    </div>

                    <div
                            class="content-highlight"
                            v-if="content['acf_fc_layout'] === 'content_composer_highlight'"
                    >
                        <div
                                class="content-highlight-copy-body"
                                v-if="content['content_highlight_copy_body']"
                                v-html="content['content_highlight_copy_body']"
                        ></div>
                        <div
                                class="content-highlight-image"
                                v-if="content['content_highlight_image_1440_1080']"
                        >
                            <img
                                    v-bind:alt="content['content_highlight_image_alt_text']"
                                    v-bind:src="content['content_highlight_image_1440_1080']"
                            >
                            <div class="image-copyright-text"
                                 v-if="content['content_highlight_image_copyright_text']"
                                 v-html="'&copy; ' + content['content_highlight_image_copyright_text']"></div>
                        </div>
                    </div>

                    <template v-if="content['acf_fc_layout'] === 'content_composer_list' && content['content_list_type'] === 'accordion'">
                        <article-accordion v-if="!content.hasOwnProperty('content_list_collapsible') || content['content_list_collapsible'] !== true"
                                :article-accordion-data="content"
                                :article-accordion-id="String(contentIndex)"
                        ></article-accordion>
                        <article-accordion-collapsible
                            v-else-if="content['content_list_collapsible'] === true"
                            :article-accordion-data="content"
                            :article-accordion-id="String(contentIndex)"
                        ></article-accordion-collapsible>
                    </template>

                    <template v-if="content['acf_fc_layout'] === 'content_composer_component' && content['content_component'] === 'content-hiv-info-graphic'">
                        <div class="article-component">
                            <content-hiv-info-graphic></content-hiv-info-graphic>
                        </div>
                    </template>

                    <!--<template v-if="content['acf_fc_layout'] === 'content_composer_tags'">
                        <tags
                                :article-primary-keyword-data="content['content_primary_keywords'] || []"
                                :article-series-keyword-data="content['content_series_keywords'] || []"
                                :article-sequencing-keyword-data="content['content_sequencing_keywords'] || []"
                        ></tags>
                    </template>-->

                    <div v-if="content['acf_fc_layout'] === 'content_composer_teaser'" class="content-teaser row mx-auto my-4">
                        <div :class="['col', 'col-12' ,'col-lg-6', 'px-0', 'content-teaser-left', 'bg-' + content['content_teaser_background_color']]">
                            <div class="content-teaser-overlay-left h-100 position-absolute"></div>
                            <div class="content-teaser-left-inner">
                                <div
                                    class="content-teaser-headline text-white font-weight-bold"
                                    v-if="content['content_teaser_headline']"
                                    v-html="content['content_teaser_headline']"
                                ></div>
                                <div
                                    class="content-teaser-subheadline text-white"
                                    v-if="content['content_teaser_subheadline']"
                                    v-html="content['content_teaser_subheadline']"
                                ></div>
                                <div
                                    class="content-teaser-text text-white mb-1 mb-lg-4"
                                    v-if="content['content_teaser_text']"
                                    v-html="content['content_teaser_text']"
                                ></div>
                              <a :class="['btn','content-teaser-cta', 'ani-btn-hover-scale-bounce', content['content_teaser_background_color'] === 'black' ? 'btn-pink-white' : 'btn-black-white']" :href="content['content_teaser_cta']['content_teaser_cta_link']" v-if="content['content_teaser_cta']['content_teaser_cta_link']" v-html="content['content_teaser_cta']['content_teaser_cta_label']"></a>
                            </div>
                        </div>
                        <div
                            class="col col-12 col-lg-6 px-0"
                            v-if="content['content_teaser_image']"
                        >
                            <div
                                class="content-teaser-image h-100 position-absolute"
                                v-bind:style="{backgroundImage: 'url(' + content['content_teaser_image']['url'] + ')'}"
                                role="img"
                            ></div>
                            <img
                                class="w-100 h-auto invisible"
                                :alt="content['content_teaser_image']['alt']"
                                v-bind:src="content['content_teaser_image']['url']"
                            />
                        </div>
                    </div>

                </template>
            </div>
            <!-- PDF Module - Only render this block if "shouldShowPdfModule" is true -->
            <div v-if="shouldShowPdfModule" class="content-highlight">
                <div class="content-highlight-copy-body">
                    <div v-html="pdfModule.pdf_module_text"></div>
                </div>
            </div>

            <!-- Sticky Questionnaire -->
             <sticky-questionnaire v-if="this.$route.params && this.$route.params['permalink']" :articleId="this.$route.params['permalink']" />

            <div class="rating-section" v-if="showRatingOption">
                <Rating :pid-param="post['id']"></Rating>
                <nav class="article-social">
                    <ul class="social-icon-listing">
                        <li class="social-icon-heading"><img src="/img/ic_share_000000.svg" alt="Share">Teilen:</li>
                        <li class="social-icon-item"><a
                            v-bind:href="facebookUrl"
                            v-on:click="shareOnFacebook($event)"
                            class="article-social-ic-on"
                        >
                            <img src="/img/ic_facebook.svg" alt="Facebook">
                        </a></li>
                        <li class="social-icon-item"><a
                            v-bind:href="'mailto:?subject='+post['title']['rendered']+'&body='+post['link']"
                            class="article-social-ic-on"
                        >
                            <img src="/img/ic_mailto.svg" alt="MailTo">
                        </a></li>
                        <li class="social-icon-item"><a
                            v-bind:href="'WhatsApp://send?text='+encodeURI(post['title']['rendered'])+ '-' +encodeURIComponent(post['link'])"
                            class="article-social-ic-on"
                        >
                            <img src="/img/ic_whatsapp.svg" alt="Whatsapp">
                        </a></li>
                    </ul>
                </nav>

            </div>

            <div class="referenzen-container" v-if="post['acf']['referenzen_list'] !== undefined && post['acf']['referenzen_list'].length > 0">
                <div class="h2 heading">Referenzen</div>
                <template v-for="(referenzen, referenzenIndex) in post['acf']['referenzen_list']">
                    <div class="referenzen" v-if="referenzen['text'] || referenzen['ref']">
                        <sup class="ref-index" v-html="referenzen['index']"></sup>
                        <div class="ref-text d-inline" v-html="referenzen['text']"></div>
                        <div class="ref-url d-inline" v-if="referenzen['ref']" v-html="'<img width=\'20px\' src=\'/img/right-arrow_e73e51.png\'>'+stringToLink(referenzen['ref'])"></div>
                    </div>
                </template>
            </div>

            <!--<tags
                    v-if="tags['primary_keyword'].length && post['acf']['content_composer']"
                    :article-primary-keyword-data="tags['primary_keyword']"
            ></tags>-->

        </div>

        <features-wide
                :features-exclude-post-permalinks="[$route.params.permalink]"
                :features-filter-params="featuresFilterParams"
                features-heading="DAS KÖNNTE Dich AUCH INTERESSIEREN"
                features-id="articleFeatures"
                v-if="isLoaded && post['acf']['config_disable_features'] !== true"
        ></features-wide>

    </main>

</template>

<script>

    // console.log('Article');

    import env from '../env';

    import smoothReflow from '../../../node_modules/vue-smooth-reflow/dist/vue-smooth-reflow.min';

    import wpApi from '../services/wpApi';

    import ArticleAccordion from './ArticleAccordion.vue';
    import ArticleAccordionCollapsible from './ArticleAccordionCollapsible.vue';
    import ContentHivInfoGraphic from './content/ContentHivInfoGraphic.vue';
    import ContentNewVideo from './content/ContentNewVideo.vue'
    import StickyQuestionnaire from './content/StickyQuestionnaire.vue'
    import FeaturesWide from './FeaturesWide.vue';
    import Tags from './Tags.vue';
    import Teaser from './Teaser.vue';
    import Rating from './Rating.vue';

    const TEASER_MAX_ITEMS_POST_DEFAULT = 4;
    const TEASER_MAX_ITEMS_POST_WITH_CHILDREN = 24;

    export default {
        mixins : [smoothReflow],
        created(){
            // this.$root.events.$on('loaded', (id)=>{
            //     this.$set(this.childrenLoaded, id, true);
            // });
            this.load();
            this.loadPDFModuleOptions();
        },
        destroyed(){
        },
        mounted(){
            this.isRendered = !(window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerendered);
            this.$smoothReflow({
                transition : 'height 800ms cubic-bezier(0.680, -0.550, 0.265, 1.550)',
            });
        },
        updated : function(){
            this.$nextTick(function(){
                this.markLinksAsExternal();
            });
        },
        components : {
            Rating,
            ArticleAccordion,
            ArticleAccordionCollapsible,
            ContentHivInfoGraphic,
            ContentNewVideo,
            StickyQuestionnaire,
            FeaturesWide,
            Tags,
            Teaser,
        },
        computed : {
            isEmpty(){
                return !this.post['acf']['content_composer'] || this.post['acf']['content_composer'].length === 0
            },
            facebookUrl(){
                return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`https://www.nochvielvor.de/${this.$route.fullPath}`)}&display=popup`;
            },
            twitterUrl(){
                return `https://x.com/intent/tweet?text=${encodeURIComponent(this.post['title']['rendered'])}&hashtags=nochvielvor&url=${encodeURIComponent(`https://www.nochvielvor.de${this.$route.fullPath}`)}`;
            },
            shouldShowPdfModule() {
                // 1) Must have load pdfModule data by xhr- see loadPDFModuleOptions()
                if (!this.pdfModule) return false;

                // 2) Check if "pdf_module_enable" is true
                if (!this.pdfModule.pdf_module_enable) return false;

                // 3) Check if current route’s permalink is in the blacklist
                //    If so, we want to *exclude* (return false).
                //    The blacklist array might have objects like:
                //       { pdf_module_blacklist_post: { post_name: "some-slug" } }
                //    or { pdf_module_blacklist_post: false }

                const currentSlug = this.$route.params['permalink'];
                const isBlacklisted = this.pdfModule.blacklist && this.pdfModule.blacklist.some((item) => {
                    return (
                        item.pdf_module_blacklist_post &&
                        item.pdf_module_blacklist_post.post_name === currentSlug
                    );
                });
                if (isBlacklisted) return false;

                return true; // If none of the above fail, it should show the module
            },
        },
        data(){
            return {
                // childrenLoaded : {},
                featuresFilterParams : {
                    seriesKeywords : [env.SERIES_KEYWORD_ID_FEATURE],
                },
                isLoaded : false,
                isRendered : false,
                showRatingOption: false,
                post : {
                    acf : {},
                    link : '',
                    title : {},
                },
                tags : {
                    'primary_keyword' : [],
                },
                pdfModule: null,
                teaserFilterParams : {},
                teaserMaxItems : TEASER_MAX_ITEMS_POST_DEFAULT,
                wpApi,
            };
        },
        metaInfo(){
            return {
                meta : [
                    {
                        vmid : 'description',
                        name : 'description',
                        content : this.post['acf']['meta_description'],
                    },
                    {
                        vmid : 'og:description',
                        property : 'og:description',
                        content : this.post['acf']['meta_og_description'],
                    },
                    {
                        vmid : 'og:image',
                        property : 'og:image',
                        content : this.post['acf']['meta_og_image_1200_630'],
                    },
                    {
                        vmid : 'og:image:alt',
                        property : 'og:image:alt',
                        content : this.post['acf']['meta_og_image_alt_text'],
                    },
                    {
                        vmid : 'og:title',
                        property : 'og:title',
                        content : this.post['acf']['meta_og_title'],
                    },
                    {
                        vmid : 'og:url',
                        property : 'og:url',
                        content : this.post['link'],
                    },
                ],
                title : this.post['title']['rendered'],
            };
        },
        methods : {
            loadPDFModuleOptions() {
                const noCacheParam = `noCache=${Date.now()}`;
                wpApi.http.get(`${wpApi.host}${wpApi.baseUrl}/wp-json/nvv/v1/pdf-options?${noCacheParam}`,{
                    cache: false,
                    forceUpdate: true,
                    headers: {
                        'Cache-Control': 'no-cache, no-store, must-revalidate, max-age=0',
                        'Pragma': 'no-cache'
                    }
                })
                .then(response => {
                    this.pdfModule = response.data;
                })
                .catch(error => {
                    console.error('Error fetching global PDF data:', error);
                });
            },
            load(){
                wpApi.http.get(wpApi.host + wpApi.baseUrl + '/wp-json/wp/v2/posts?slug=' + this.$route.params['permalink'])
                    .then((response)=>{
                        console.log('response', response);
                        if (Array.isArray(response.data) === false || response.data.length === 0) {
                            this.$router.push('/404');
                            return;
                        }
                        this.post = response.data[0];
                        this.updateJsonLd();

                        if(this.post['acf']['content_composer'] !== undefined){
                            this.post['acf']['content_composer'].forEach(contentComposer =>{
                                if(contentComposer['acf_fc_layout'] !== undefined &&
                                    contentComposer['acf_fc_layout'] == 'content_composer_copy_body' &&
                                    contentComposer['content_copy_body'] !== undefined ){
                                    let $elem = $("<div />").html(contentComposer['content_copy_body']);
                                    $elem.find("script").each(function(){
                                        let srcAttr = $(this).attr('src');
                                        if(typeof srcAttr !== typeof undefined && srcAttr !== false){
                                            let externalScript = document.createElement('script')
                                            externalScript.setAttribute('src', srcAttr);
                                            document.head.appendChild(externalScript)
                                        }else{
                                            eval($(this).text());
                                        }

                                    }).remove();
                                }
                            });
                        }

                        const preview = !!this.$route.query['preview'];
                        if (this.post['acf']['visibility_published'] !== true && preview === false) {
                            this.$router.push('/404');
                            return;
                        }

                        if (this.post['acf']['hierarchy_child_posts'] && this.post['acf']['hierarchy_child_posts'].length) {
                            this.teaserFilterParams = {
                                posts : this.post['acf']['hierarchy_child_posts'],
                            };
                            this.teaserMaxItems = TEASER_MAX_ITEMS_POST_WITH_CHILDREN;
                        } else {
                            this.teaserFilterParams = {
                                tags : this.post['tags'],
                                primaryKeywords : this.post['primary_keyword'],
                                seriesKeywords : this.post['series_keyword'],
                            };
                        }

                        if (this.post['acf']['config_teaser_max_items'] !== undefined && this.post['acf']['config_teaser_max_items'] !== null && this.post['acf']['config_teaser_max_items'] !== '') {
                            this.teaserMaxItems = Number(this.post['acf']['config_teaser_max_items']);
                        }

                        if(this.post['acf']['related_posts'] !== undefined)
                        {
                            this.featuresFilterParams.posts = this.post['acf']['related_posts'];
                        }

                        this.$root.states.articleHasVideo = this.post['acf']['config_disable_header'] !== true && this.post['acf']['teaser_video_youtube_id'];

                        if(this.$root.cache.menus !== undefined && this.$root.cache.menus.hasOwnProperty('footer-menu-legal')){
                            this.showRatingOption = !this.$root.cache.menus['footer-menu-legal'].some( footerPost => footerPost.object == 'post' && parseInt(footerPost.object_id) === this.post.id );
                        }else{
                            this.showRatingOption = true;
                        }
                        // this.featuresFilterParams = {
                        //     tags : this.post['tags'],
                        //     primaryKeywords : this.post['primary_keyword'],
                        //     seriesKeywords : this.post['series_keyword'],
                        // };

                        // NOTE: As WP returns the post tags as ids only, subsequent requests would be required for resolving
                        // them. So instead the tags are all fetched at once in the app component and cached. It need to be
                        // considered though, that by maximum 100 tags are returned by WP.

                        this.$root.promises.tags.then(()=>{
                            this.post['primary_keyword'].forEach((id)=>{
                                const primaryKeyword = this.$root.cache.tags['primary_keyword'].find((element)=>{
                                    return element['id'] === id;
                                });
                                if (primaryKeyword) {
                                    this.tags['primary_keyword'].push(primaryKeyword);
                                }
                            });
                        });

                        // NOTE: To ensure that the correct page title is tracked, the vue-analytics and/or vue-gtm calls are
                        // wrapped in a timeout, as vue-meta needs a tick to update the title.

                        window.setTimeout(()=>{
                            // this.$ga.page(this.$route.fullPath);
                            try {
                                this.$gtm.trackEvent({
                                    event : 'Pageview',
                                    url : this.$route.path.toLowerCase().replace(/\/$/, ""),
                                });
                                this.$gtm.trackEvent({
                                    event : 'scrolldepth',
                                    url : this.$route.path.toLowerCase().replace(/\/$/, ""),
                                });
                            } catch (e) {
                                console.log(e);
                            }
                        });

                        // NOTE: To simplify handling of tables in the WYSIWYG editor on one hand and to avoid overflowing
                        // tables on the other hand, tables are wrapped into an element with overflow scrolling.

                        window.setTimeout(()=>{
                            this.wrapTableHtml();
                            if($(this.$el).find('a.ot-sdk-show-settings').length) {
                                $(this.$el).find('a.ot-sdk-show-settings').on('click', function(){
                                    window.OneTrust.ToggleInfoDisplay();
                                });
                            }
                        });

                        // NOTE: The additional markLinksAsExternal call is required for SSR as update is not executed there. It
                        // is required though to change the behavior as otherwise duplicate handlers would be registered -
                        // see: https://vuejs.org/v2/api/#updated

                        // window.setTimeout(()=>{
                        //     this.markLinksAsExternal();
                        // });
                        if(this.$route.path.toLowerCase().replace(/\/$/, "") == '/podcast') {
                            this.includetTrackingPixcelScript();
                        }
                        this.isLoaded = true;
                    })
                    .catch((error)=>{
                        console.log('error', error);
                        this.$router.push('/404');
                    });
            },
            markLinksAsExternal(){
                Array.from(this.$el.querySelectorAll('a')).forEach((a)=>{
                    if (a.hostname !== location.hostname && a.hostname.length > 0) {
                        a.classList.add('link-external');
                        a.addEventListener('click', (event)=>{
                            event.preventDefault();
                            this.$root.states.popupExternalLinkHref = a.href;
                        });
                    }
                });
            },
            shareOnFacebook(event){
                event.preventDefault();
                window.open(this.facebookUrl, 'facebook', 'left=50,top=50,width=670,height=348');
            },
            shareOnTwitter(event){
                event.preventDefault();
                window.open(this.twitterUrl, 'twitter', 'left=50,top=50,width=550,height=498');
            },
            wrapTableHtml(){
                $(this.$el).find('table').wrap('<div class="table-wrapper"></div>')
            },
            isValidURL(str){
                try {
                    new URL(str);
                } catch (error) {
                    return false;
                }
                return true;
            },
            stringToLink(str){
                if(!this.isValidURL(str)){
                    return str;
                }
                return '<a href="'+str+'" target="_blank">'+str+'</a>';
            },
            headerImage(){

                let headerImage = '';
                if(this.post['acf']['teaser_image_960_720'] !== undefined){
                    headerImage = this.post['acf']['teaser_image_960_720'];
                }else if(this.post['acf']['teaser_image_3840_3840'] !== undefined){
                    headerImage = this.post['acf']['teaser_image_3840_3840'];
                }

                if (this.post['acf']['teaser_image_720_720'] !== undefined && window.matchMedia('(min-width: 1200px)').matches) {
                    headerImage = this.post['acf']['teaser_image_720_720'];
                }
                else if (this.post['acf']['teaser_image_3840_1536'] !== undefined && window.matchMedia('(min-width: 1440px)').matches) {
                    headerImage = this.post['acf']['teaser_image_3840_1536'];
                }
                else if (this.post['acf']['teaser_image_3840_3840'] !== undefined && window.matchMedia('(min-width: 1920px)').matches) {
                    headerImage = this.post['acf']['teaser_image_3840_3840'];
                }

                if(headerImage != '')
                {
                    return wpApi.stripHost(headerImage);
                }
            },
            includetTrackingPixcelScript() {
              if("__tcfapi" in window){__tcfapi("getTCData",2,function (x,s){ if("tcString" in x){(new Image()).src = "https://a.twiago.com/adtrack.php?id=7299&gdpr_consent="+x.tcString;}else{(new Image()).src = "https://a.twiago.com/adtrack.php?id=7299";}})}else{(new Image()).src = "https://a.twiago.com/adtrack.php?id=7299";}
            },
            updateJsonLd() {
                const existingScript = document.querySelector('script[type="application/ld+json"]');
                if (existingScript) {
                    existingScript.remove();
                }

                const script = document.createElement("script");
                script.type = "application/ld+json";
                script.innerHTML = JSON.stringify(this.jsonLd());
                document.head.appendChild(script);
            },
            jsonLd() {
                const title = this.post.title && this.post.title.rendered ? this.post.title.rendered : '';
                const imageUrl = this.headerImage() || '';
                const authorName = this.post.acf && this.post.acf.author_name ? this.post.acf.author_name : '';
                const datePublished = this.post.date || '';
                const dateModified = this.post.modified || '';
                const articleUrl = this.post.link || '';
                const publisherName = "nochvielvor";
                const publisherLogoUrl = "https://www.nochvielvor.de/favicon.ico";
                const articleBody = this.getArticleBody();
                const wordCount = this.getWordCount();
                const keywords = this.post.acf && this.post.acf.keywords ? this.post.acf.keywords.join(", ") : '';
                const description = this.post.acf && this.post.acf.meta_description ? this.post.acf.meta_description : '';

                return {
                    "@context": "https://schema.org",
                    "@type": "Article",
                    "headline": title,
                    "image": imageUrl,
                    "author": {
                    "@type": "Person",
                    "name": authorName
                    },
                    "datePublished": datePublished,
                    "dateModified": dateModified,
                    "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": articleUrl
                    },
                    "publisher": {
                    "@type": "Organization",
                    "name": publisherName,
                    "logo": {
                        "@type": "ImageObject",
                        "url": publisherLogoUrl
                    }
                    },
                    "articleBody": articleBody,
                    "wordCount": wordCount,
                    "keywords": keywords,
                    "description": description
                };
            },
            // Function to extract and return the article's body content for JSON-LD
            getArticleBody() {
                return this.post.acf.content_composer
                    .filter(content => content.acf_fc_layout === 'content_composer_copy_body')
                    .map(content => content.content_copy_body)
                    .join(" ");
            },
            // Function to calculate and return the word count
            getWordCount() {
                return this.getArticleBody().split(/\s+/).length;
            }
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .article {
        /*overflow-x: visible !important;*/
        /*overflow-y: hidden !important;*/
        overflow: hidden;
        will-change: height;
        .article-inner {
            width: calc(100% - 7.5rem - 7.5rem);
            margin: 0 auto;
            padding: 5.5rem 0 0 0;
            @media screen and (max-width: 767px) {
                width: 100%;
                padding: 5.5rem 1.5rem 0 1.5rem;
            }
            @media screen and (min-width: 1200px) {
                width: calc(100% - 7.5rem * #{$factor-1200} - 7.5rem * #{$factor-1200});
                padding: 5.5rem * $factor-1200 0 0 0;
            }
            @media screen and (min-width: 1440px) {
                width: calc(100% - 7.5rem * #{$factor-1440} - 7.5rem * #{$factor-1440});
                padding: 5.5rem * $factor-1440 0 0 0;
            }
            @media screen and (min-width: 1920px) {
                width: calc(100% - 7.5rem * #{$factor-1920} - 7.5rem * #{$factor-1920});
                padding: 5.5rem * $factor-1920 0 0 0;
            }
            @media screen and (min-width: 2400px) {
                width: calc(100% - 7.5rem * #{$factor-2400} - 7.5rem * #{$factor-2400});
                padding: 5.5rem * $factor-2400 0 0 0;
            }
        }
        .article-hero-container {
            margin: -5.5rem -1.5rem 1.875rem;
            @media screen and (min-width: 768px) {
                margin-left: -7.5rem;
                margin-right: -7.5rem;
                margin-bottom: 3.75rem;
            }
            @media screen and (min-width: 1200px) {
                margin: -5.5rem * $factor-1200 -7.5rem * $factor-1200 3.75rem * $factor-1200;
                //height: 24rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: -5.5rem * $factor-1440 -7.5rem * $factor-1440 3.75rem * $factor-1440;
                //height: 24rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: -5.5rem * $factor-1920 -7.5rem * $factor-1920 3.75rem * $factor-1920;
                //height: 24rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: -5.5rem * $factor-2400 -7.5rem * $factor-2400 3.75rem * $factor-2400;
                //height: 24rem * $factor-2400;
            }
            .article-hero {
                position: relative;
                height: 258px;
                background-color: rgba(0, 0, 0, 0.25);
                background-position: 50% 50%;
                background-repeat: no-repeat;
                background-size: cover;
                @media screen and (min-width: 768px) {
                    height: 480px;
                }
                .article-hero-caption {
                    display: flex;
                    flex-direction: column;
                    position: absolute;
                    left: 1.5rem + 1.75rem + 1.5rem;
                    top: 0;
                    width: calc(50% - 1.5rem - 1.75rem - 1.5rem - 1.5rem);
                    height: 100%;
                    @media screen and (max-width: 767px) {
                        left: 1.5rem;
                        width: calc(100% - 1.5rem - 1.5rem);
                    }
                    @media screen and (min-width: 1200px) {
                        left: (1.5rem + 1.75rem + 1.5rem) * $factor-1200;
                        width: calc(50% - 1.5rem * #{$factor-1200} - 1.75rem * #{$factor-1200} - 1.5rem * #{$factor-1200} - 1.5rem * #{$factor-1200});
                    }
                    @media screen and (min-width: 1440px) {
                        left: (1.5rem + 1.75rem + 1.5rem) * $factor-1440;
                        width: calc(50% - 1.5rem * #{$factor-1440} - 1.75rem * #{$factor-1440} - 1.5rem * #{$factor-1440} - 1.5rem * #{$factor-1440});
                    }
                    @media screen and (min-width: 1920px) {
                        left: (1.5rem + 1.75rem + 1.5rem) * $factor-1920;
                        width: calc(50% - 1.5rem * #{$factor-1920} - 1.75rem * #{$factor-1920} - 1.5rem * #{$factor-1920} - 1.5rem * #{$factor-1920});
                    }
                    @media screen and (min-width: 2400px) {
                        left: (1.5rem + 1.75rem + 1.5rem) * $factor-2400;
                        width: calc(50% - 1.5rem * #{$factor-2400} - 1.75rem * #{$factor-2400} - 1.5rem * #{$factor-2400} - 1.5rem * #{$factor-2400});
                    }
                    &.article-hero-caption-right {
                        left: auto;
                        right: 1.5rem + 1.75rem + 1.5rem;
                        @media screen and (max-width: 767px) {
                            left: auto;
                            right: 1.5rem;
                            width: calc(100% - 1.5rem - 1.5rem);
                            text-align: right;
                        }
                        @media screen and (min-width: 1200px) {
                            left: auto;
                            right: (1.5rem + 1.75rem + 1.5rem) * $factor-1200;
                        }
                        @media screen and (min-width: 1440px) {
                            left: auto;
                            right: (1.5rem + 1.75rem + 1.5rem) * $factor-1440;
                        }
                        @media screen and (min-width: 1920px) {
                            left: auto;
                            right: (1.5rem + 1.75rem + 1.5rem) * $factor-1920;
                        }
                        @media screen and (min-width: 2400px) {
                            left: auto;
                            right: (1.5rem + 1.75rem + 1.5rem) * $factor-2400;
                        }
                    }
                    .content-headline {
                      color: $color-nochvielvor-white;
                      &.content-headline-black {
                          color: $color-nochvielvor-black;
                      }
                      &.content-headline-pink {
                          color: $color-nochvielvor-pink;
                      }
                      &.content-headline-white {
                          color: $color-nochvielvor-white;
                      }
                      &.content-headline-none {
                          display: none;
                      }
                    }
                }
                .overlay {
                    background-color: rgba(0, 0, 0, 0.5);
                    position: absolute;
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                }
            }
        }
        .article-hero-video {
            position: relative;
            //height: 24rem;
            margin-left: -7.5rem;
            margin-right: -7.5rem;
            margin-top: -5.5rem;
            margin-bottom: 2rem;
            @media screen and (max-width: 767px) {
                margin-left: -1.5rem;
                margin-right: -1.5rem;
                margin-bottom: 2rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                //height: 24rem * $factor-1200;
                margin-left: -7.5rem * $factor-1200;
                margin-right: -7.5rem * $factor-1200;
                margin-top: -5.5rem * $factor-1200;
                margin-bottom: 2rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                //height: 24rem * $factor-1440;
                margin-left: -7.5rem * $factor-1440;
                margin-right: -7.5rem * $factor-1440;
                margin-top: -5.5rem * $factor-1440;
                margin-bottom: 2rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                //height: 24rem * $factor-1920;
                margin-left: -7.5rem * $factor-1920;
                margin-right: -7.5rem * $factor-1920;
                margin-top: -5.5rem * $factor-1920;
                margin-bottom: 2rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                //height: 24rem * $factor-2400;
                margin-left: -7.5rem * $factor-2400;
                margin-right: -7.5rem * $factor-2400;
                margin-top: -5.5rem * $factor-2400;
                margin-bottom: 2rem * $factor-2400;
            }
            > div {
                height: 100% !important;
                > iframe {
                    height: 100% !important;
                }
            }
        }
        .article-social {
            text-align: right;
            margin-bottom: 2rem;
            @media screen and (min-width: 1200px) {
                margin-bottom: 2rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin-bottom: 2rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin-bottom: 2rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin-bottom: 2rem * $factor-2400;
            }
            .article-social-icon {
                display: block;
                width: 1.25rem;
                height: 1.25rem;
                margin: auto;
                text-align: center;
                @media screen and (min-width: 1200px) {
                    width: 1.25rem * $factor-1200;
                    height: 1.25rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    width: 1.25rem * $factor-1440;
                    height: 1.25rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    width: 1.25rem * $factor-1920;
                    height: 1.25rem * $factor-1920;
                    margin: 0 0.25rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    width: 1.25rem * $factor-2400;
                    height: 1.25rem * $factor-2400;
                    margin: 0 0.25rem * $factor-2400;
                }
            }
        }
        .article-content {
            padding-bottom: 3.5rem;
            @media screen and (min-width: 1200px) {
                padding-bottom: 3.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding-bottom: 3.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                padding-bottom: 3.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                padding-bottom: 3.5rem * $factor-2400;
            }
            &:empty,
            &.isEmpty {
                padding-bottom: 0;
            }
            .tags {
                margin-top: (3.5rem - 0.25rem);
                @media screen and (min-width: 1200px) {
                    margin-top: (3.5rem - 0.25rem) * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    margin-top: (3.5rem - 0.25rem) * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    margin-top: (3.5rem - 0.25rem) * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    margin-top: (3.5rem - 0.25rem) * $factor-2400;
                }
                &:first-child {
                    margin-top: -0.25rem;
                    @media screen and (min-width: 1200px) {
                        margin-top: -0.25rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        margin-top: -0.25rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        margin-top: -0.25rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        margin-top: -0.25rem * $factor-2400;
                    }
                }
                &:last-child {
                    margin-bottom: -0.25rem;
                    @media screen and (min-width: 1200px) {
                        margin-bottom: -0.25rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        margin-bottom: -0.25rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        margin-bottom: -0.25rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        margin-bottom: -0.25rem * $factor-2400;
                    }
                }
            }
        }
        .article-video {
            margin: 2rem 0 3.5rem 0;
            @media screen and (max-width: 767px) {
                margin: 2rem * $factor-720 0 3.5rem * $factor-720 0;
            }
            @media screen and (min-width: 1200px) {
                margin: 2rem * $factor-1200 0 3.5rem * $factor-1200 0;
            }
            @media screen and (min-width: 1440px) {
                margin: 2rem * $factor-1440 0 3.5rem * $factor-1440 0;
            }
            @media screen and (min-width: 1920px) {
                margin: 2rem * $factor-1920 0 3.5rem * $factor-1920 0;
            }
            @media screen and (min-width: 2400px) {
                margin: 2rem * $factor-2400 0 3.5rem * $factor-2400 0;
            }
        }
        .article-featured-person {
            margin: 4rem 0;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            @media screen and (max-width: 767px) {
                margin: 4rem * $factor-720 0;
            }
            @media screen and (min-width: 1200px) {
                margin: 4rem * $factor-1200 0;
            }
            @media screen and (min-width: 1440px) {
                margin: 4rem * $factor-1440 0;
            }
            @media screen and (min-width: 1920px) {
                margin: 4rem * $factor-1920 0;
            }
            @media screen and (min-width: 2400px) {
                margin: 4rem * $factor-2400 0;
            }
            &:first-child {
                margin-top: 0;
            }
            .article-featured-person-details {
                display: flex;
                flex-direction: column;
                max-width: 20rem;
                @media screen and (max-width: 767px) {
                    width: calc(100% - 7.5rem * #{$factor-720} - 1rem * #{$factor-720});
                }
                @media screen and (min-width: 1200px) {
                    max-width: 20rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    max-width: 20rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    max-width: 20rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    max-width: 20rem * $factor-2400;
                }
                > * {
                    &:first-child {
                        margin-top: auto;
                    }
                    &:last-child {
                        margin-bottom: auto;
                    }
                }
            }
        }
        .article-address {
            margin: 2rem 0;
            font-size: 1rem;
            line-height: 1.6;
            @media screen and (max-width: 767px) {
                margin: 2rem * $factor-720 0;
                font-size: 1rem * $factor-720;
            }
            @media screen and (min-width: 768px) {
                font-size: 18px;
            }
            /*@media screen and (min-width: 1200px) {
                margin: 2rem * $factor-1200 0;
                font-size: 1rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 2rem * $factor-1440 0;
                font-size: 1rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 2rem * $factor-1920 0;
                font-size: 1rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 2rem * $factor-2400 0;
                font-size: 1rem * $factor-2400;
            }*/
            a {
                position: relative;
                padding-left: 1em;
                display: inline-block;
                color: $color-nochvielvor-pink;
                // word-break: break-all;
                &:before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 1em;
                    height: 100%;
                    background-image: url(/img/ic_chevron_inline_right_e73e51.svg);
                    background-position: 0 50%;
                    background-repeat: no-repeat;
                    background-size: 0.8em 0.8em;
                }
            }
        }
        .article-component {
            margin-left: -7.5rem;
            margin-right: -7.5rem;
            @media screen and (max-width: 767px) {
                margin-left: -1.5rem;
                margin-right: -1.5rem;
            }
            @media screen and (min-width: 1200px) {
                margin-left: -7.5rem * $factor-1200;
                margin-right: -7.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin-left: -7.5rem * $factor-1440;
                margin-right: -7.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin-left: -7.5rem * $factor-1920;
                margin-right: -7.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin-left: -7.5rem * $factor-2400;
                margin-right: -7.5rem * $factor-2400;
            }
        }
        .content-headline {
            margin: auto 0 2.5rem 0;
            color: $color-nochvielvor-black;
            text-transform: uppercase;
            font-size: 22px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.2;
            word-break: break-word;
            @media screen and (max-width: 767px) {
                margin: auto 0 2.5rem * $factor-720 0;
            }
            @media screen and (min-width: 768px) {
                font-size: 30px;
                line-height: 1.29;
            }
            @media screen and (min-width: 1200px) {
                margin: auto 0 2.5rem * $factor-1200 0;
            }
            @media screen and (min-width: 1440px) {
                margin: auto 0 2.5rem * $factor-1440 0;
                //font-size: 1.75rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: auto 0 2.5rem * $factor-1920 0;
                //font-size: 1.75rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: auto 0 2.5rem * $factor-2400 0;
                //font-size: 1.75rem * $factor-2400;
            }
            &.content-headline-black {
                color: $color-nochvielvor-black;
            }
            &.content-headline-pink {
                color: $color-nochvielvor-pink;
            }
            &.content-headline-white {
                color: $color-nochvielvor-white;
            }
            &.content-headline-none {
                display: none;
            }
        }
        h2.content-subline {
            margin: 3rem 0 1.5rem 0;
            font-size: 18px;
            font-weight: bold;
            margin: 3rem * $factor-720 0 1.5rem * $factor-720 0;
            @media screen and (min-width: 768px) {
                margin: 3rem * $factor-960 0 1.5rem * $factor-960 0;
                font-size: 28px;
                //font-size: 1.5rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                margin: 3rem * $factor-1200 0 1.5rem * $factor-1200 0;
                //font-size: 1.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 3rem * $factor-1440 0 1.5rem * $factor-1440 0;
                //font-size: 1.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 3rem * $factor-1920 0 1.5rem * $factor-1920 0;
                //font-size: 1.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 3rem * $factor-2400 0 1.5rem * $factor-2400 0;
                //font-size: 1.5rem * $factor-2400;
            }
            &:last-child {
                margin-bottom: 0;
            }
        }
        h3.content-subline {
            margin: 0;
            //font-size: 1.25rem;
            font-size: 1rem;
            font-weight: bold;
            @media screen and (max-width: 767px) {
                //font-size: 1.25rem * $factor-720;
                font-size: 1rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                //font-size: 1.25rem * $factor-1200;
                font-size: 1rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                //font-size: 1.25rem * $factor-1440;
                font-size: 1rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                //font-size: 1.25rem * $factor-1920;
                font-size: 1rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                //font-size: 1.25rem * $factor-2400;
                font-size: 1rem * $factor-2400;
            }
        }
        &:not([data-content-class="content-class-legal"]):not([data-content-class="content-class-list"]) {
            .content-copy-body {
                &.isFirstOfLayout {
                    p {
                        &:first-child {
                            min-height: 5.25rem;
                            &::first-letter {
                                margin-left: -0.075em;
                                padding-top: 0.2em;
                                padding-right: 0.1em;
                                float: left;
                                font-size: 5.25rem;
                                font-weight: bold;
                                line-height: 0.5;
                                @media screen and (max-width: 767px) {
                                    font-size: 5.25rem * $factor-720;
                                }
                                @media screen and (min-width: 1200px) {
                                    font-size: 5.25rem * $factor-1200;
                                }
                                /*@media screen and (min-width: 1440px) {
                                    font-size: 5.25rem * $factor-1440;
                                }
                                @media screen and (min-width: 1920px) {
                                    font-size: 5.25rem * $factor-1920;
                                }
                                @media screen and (min-width: 2400px) {
                                    font-size: 5.25rem * $factor-2400;
                                }*/
                                @supports (-moz-appearance: none) {
                                    padding-top: 0.1em;
                                }
                            }
                        }
                    }
                }
                &.isLastOfLayout {
                }
            }
        }
        .content-copy-body,
        .content-footnotes {
            margin: 0 0 1rem 0;
            //font-size: 1rem;
            //line-height: 1.6;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.6;
            @media screen and (max-width: 767px) {
                margin: 0 0 1rem * $factor-720 0;
                //font-size: 1rem * $factor-720;
            }
            @media screen and (min-width: 768px) {
                font-size: 18px;
                font-weight: 400;
                line-height: 1.6;
            }
            @media screen and (min-width: 1200px) {
                margin: 0 0 1rem * $factor-1200 0;
                //font-size: 1rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 0 0 1rem * $factor-1440 0;
                //font-size: 1rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 0 0 1rem * $factor-1920 0;
                //font-size: 1rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 0 0 1rem * $factor-2400 0;
                //font-size: 1rem * $factor-2400;
            }
            &:last-child {
                margin-bottom: 0;
            }
            a {
                position: relative;
                padding-left: 1em;
                color: $color-nochvielvor-pink;
                @media screen and (max-width: 767px) {
                    word-break: break-word;
                    width: 1em;
                    background-image: url(/img/ic_chevron_inline_right_e73e51.svg);
                    background-position: 0 50%;
                    background-repeat: no-repeat;
                    background-size: 0.8em 0.8em;
                }
                @media screen and (min-width: 768px) {
                    display: inline-block;
                    &:before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 1em;
                        height: 100%;
                        background-image: url(/img/ic_chevron_inline_right_e73e51.svg);
                        background-position: 0 50%;
                        background-repeat: no-repeat;
                        background-size: 0.8em 0.8em;
                    }
                }
            }
            ol, ul {
                position: relative;
                margin: 0 0 1rem 0;
                padding: 0;
                list-style-type: none;
                @media screen and (max-width: 767px) {
                    margin: 0 0 1rem * $factor-720 0;
                }
                @media screen and (min-width: 1200px) {
                    margin: 0 0 1rem * $factor-1200 0;
                }
                @media screen and (min-width: 1440px) {
                    margin: 0 0 1rem * $factor-1440 0;
                }
                @media screen and (min-width: 1920px) {
                    margin: 0 0 1rem * $factor-1920 0;
                }
                @media screen and (min-width: 2400px) {
                    margin: 0 0 1rem * $factor-2400 0;
                }
            }
            li {
                margin-left: 1.5em;
                padding: 0;
            }
            ol {

                // NOTE: The counter identifier previously was `list-item` which caused different bugs in different browsers,
                // thus it was renamed to `list-counter` here to fix it.
                //
                // See: https://stackoverflow.com/questions/53420948/css-counter-identifier-value

                counter-reset: list-counter;
                > li {
                    counter-increment: list-counter;
                    &:before {
                        content: counter(list-counter) '.';
                        position: absolute;
                        left: 0;
                    }
                }
            }
            ul {
                margin-left: 0.75em;
                > li {
                    &:before {
                        content: '';
                        position: absolute;
                        left: 0;
                        width: 0.5em;
                        height: 0.5em;
                        margin-top: 1ex;
                        background: $color-nochvielvor-pink;
                        transform: rotate(-45deg);
                    }
                }
            }
            p {
                margin: 0 0 1rem 0;
                @media screen and (min-width: 1200px) {
                    margin: 0 0 1rem * $factor-1200 0;
                }
                @media screen and (min-width: 1440px) {
                    margin: 0 0 1rem * $factor-1440 0;
                }
                @media screen and (min-width: 1920px) {
                    margin: 0 0 1rem * $factor-1920 0;
                }
                @media screen and (min-width: 2400px) {
                    margin: 0 0 1rem * $factor-2400 0;
                }
                &:last-child {
                    margin-bottom: 0;
                }
            }
            table {
                margin: 0 0 1rem 0;
                border: 1px solid $color-nochvielvor-black;
                @media screen and (min-width: 1200px) {
                    margin: 0 0 1rem * $factor-1200 0;
                }
                @media screen and (min-width: 1440px) {
                    margin: 0 0 1rem * $factor-1440 0;
                }
                @media screen and (min-width: 1920px) {
                    margin: 0 0 1rem * $factor-1920 0;
                }
                @media screen and (min-width: 2400px) {
                    margin: 0 0 1rem * $factor-2400 0;
                }
                th,
                td {
                    padding: 0.25rem;
                    border: 1px solid $color-nochvielvor-black;
                    text-align: left;
                    vertical-align: top;
                    @media screen and (min-width: 1200px) {
                        padding: 0.25rem * $factor-1200;
                    }
                    @media screen and (min-width: 1440px) {
                        padding: 0.25rem * $factor-1440;
                    }
                    @media screen and (min-width: 1920px) {
                        padding: 0.25rem * $factor-1920;
                    }
                    @media screen and (min-width: 2400px) {
                        padding: 0.25rem * $factor-2400;
                    }
                }
            }
        }
        .content-footnotes {
            margin-top: 4rem;
            font-style: italic;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 1.6;
            @media screen and (max-width: 767px) {
                margin-top: 4rem * $factor-720;
                //font-size: 1rem * $factor-720 * 0.75;
            }
            @media screen and (min-width: 768px) {
                font-size: 20px;
                font-weight: 400;
                line-height: 1.6;
            }
            @media screen and (min-width: 1200px) {
                margin-top: 4rem * $factor-1200;
                //font-size: 1rem * $factor-1200 * 0.75;
            }
            @media screen and (min-width: 1440px) {
                margin-top: 4rem * $factor-1440;
                //font-size: 1rem * $factor-1440 * 0.75;
            }
            @media screen and (min-width: 1920px) {
                margin-top: 4rem * $factor-1920;
                //font-size: 1rem * $factor-1920 * 0.75;
            }
            @media screen and (min-width: 2400px) {
                margin-top: 4rem * $factor-2400;
                //font-size: 1rem * $factor-2400 * 0.75;
            }
        }
        .content-image-container {
            margin: 4rem -7.5rem;
            @media screen and (max-width: 767px) {
                margin: 4rem * $factor-720 -1.5rem;
            }
            @media screen and (min-width: 1200px) {
                margin: 4rem * $factor-1200 -7.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 4rem * $factor-1440 -7.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 4rem * $factor-1920 -7.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 4rem * $factor-2400 -7.5rem * $factor-2400;
            }
            &:last-child {
                margin-bottom: 0;
            }
            .content-image {
                font-size: 1rem;
                @media screen and (min-width: 768px) {
                    position: relative;
                    height: 24rem;
                    overflow: hidden;
                }
                @media screen and (min-width: 1200px) {
                    height: 24rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    height: 24rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    height: 24rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    height: 24rem * $factor-2400;
                }
                img {
                    width: 100%;
                    height: auto;
                    @media screen and (min-width: 768px) {
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
            }
            .image-copyright-text {
                padding-left: 5px;
                padding-right: 5px;
            }
        }
        .content-highlight {
            display: flex;
            flex-direction: row;
            margin: 4rem -7.5rem;
            padding: 2rem 7.5rem;
            background-color: $color-nochvielvor-pink;
            @media screen and (max-width: 767px) {
                flex-direction: column;
                margin: 4rem * $factor-720 -1.5rem;
                padding-left: 1.5rem;
                padding-right: 1.5rem;
            }
            @media screen and (min-width: 1200px) {
                margin: 4rem * $factor-1200 -7.5rem * $factor-1200;
                padding: 2rem * $factor-1200 7.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 4rem * $factor-1440 -7.5rem * $factor-1440;
                padding: 2rem * $factor-1440 7.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 4rem * $factor-1920 -7.5rem * $factor-1920;
                padding: 2rem * $factor-1920 7.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 4rem * $factor-2400 -7.5rem * $factor-2400;
                padding: 2rem * $factor-2400 7.5rem * $factor-2400;
            }
            > *:nth-child(2) {
                margin-left: 2rem;
                @media screen and (max-width: 767px) {
                    margin-left: 0;
                    margin-top: 2rem * $factor-720;
                }
                @media screen and (min-width: 1200px) {
                    margin-left: 2rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    margin-left: 2rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    margin-left: 2rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    margin-left: 2rem * $factor-2400;
                }
            }
            .content-highlight-copy-body {
                color: $color-nochvielvor-white;
                font-size: 12px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.6;
                @media screen and (min-width: 768px) {
                    font-size: 20px;
                    font-weight: 400;
                    line-height: 1.6;
                }
                /*@media screen and (max-width: 767px) {
                    font-size: 1rem * $factor-720;
                }
                @media screen and (min-width: 1200px) {
                    font-size: 1rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    font-size: 1rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    font-size: 1rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    font-size: 1rem * $factor-2400;
                }*/
                a {
                    color: $color-nochvielvor-white;
                    text-decoration: underline;
                    // word-break: break-all;
                }
                p {
                    margin: 0 0 1rem 0;
                    @media screen and (min-width: 1200px) {
                        margin: 0 0 1rem * $factor-1200 0;
                    }
                    @media screen and (min-width: 1440px) {
                        margin: 0 0 1rem * $factor-1440 0;
                    }
                    @media screen and (min-width: 1920px) {
                        margin: 0 0 1rem * $factor-1920 0;
                    }
                    @media screen and (min-width: 2400px) {
                        margin: 0 0 1rem * $factor-2400 0;
                    }
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
            .content-highlight-image {
                width: 50%;
                min-width: 50%;
                @media screen and (max-width: 767px) {
                    width: 100%;
                    min-width: 100%;
                }
                img {
                    left: 0;
                    top: 50%;
                    width: 100%;
                    height: auto;
                }
                .image-copyright-text {
                    color: #fff;
                }
            }
        }
        .content-video-title {
            margin: 2.25rem 0;
            font-size: 2.25rem;
            font-weight: bold;
            text-transform: uppercase;
            @media screen and (max-width: 767px) {
                margin: 2.25rem * $factor-720 0;
                font-size: 2.25rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                margin: 2.25rem * $factor-1200 0;
                font-size: 2.25rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 2.25rem * $factor-1440 0;
                font-size: 2.25rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 2.25rem * $factor-1920 0;
                font-size: 2.25rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 2.25rem * $factor-2400 0;
                font-size: 2.25rem * $factor-2400;
            }
        }
        .content-video-summary {
            margin: 1rem 0;
            font-size: 1rem;
            line-height: 1.6;
            @media screen and (max-width: 767px) {
                margin: 1rem * $factor-720 0;
                font-size: 1rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                margin: 1rem * $factor-1200 0;
                font-size: 1rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 1rem * $factor-1440 0;
                font-size: 1rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 1rem * $factor-1920 0;
                font-size: 1rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 1rem * $factor-2400 0;
                font-size: 1rem * $factor-2400;
            }
            &:last-child {
                margin-bottom: 0;
            }
            a {
                color: $color-nochvielvor-pink;
            }
        }
        .content-featured-person-image {
            width: 7.5rem;
            height: 7.5rem;
            max-width: 7.5rem;
            margin-right: 1rem;
            background-color: $color-nochvielvor-black;
            background-position: 50% 50%;
            background-repeat: no-repeat;
            background-size: cover;
            border-radius: 50%;
            @media screen and (max-width: 767px) {
                width: 7.5rem * $factor-720;
                height: 7.5rem * $factor-720;
                max-width: 7.5rem * $factor-720;
                margin-right: 1rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                width: 7.5rem * $factor-1200;
                height: 7.5rem * $factor-1200;
                max-width: 7.5rem * $factor-1200;
                margin-right: 1rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                width: 7.5rem * $factor-1440;
                height: 7.5rem * $factor-1440;
                max-width: 7.5rem * $factor-1440;
                margin-right: 1rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                width: 7.5rem * $factor-1920;
                height: 7.5rem * $factor-1920;
                max-width: 7.5rem * $factor-1920;
                margin-right: 1rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                width: 7.5rem * $factor-2400;
                height: 7.5rem * $factor-2400;
                max-width: 7.5rem * $factor-2400;
                margin-right: 1rem * $factor-2400;
            }
        }
        .content-featured-person-name {
            color: $color-nochvielvor-pink;
            font-size: 1.25rem;
            font-weight: bold;
            @media screen and (max-width: 767px) {
                font-size: 1.25rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                font-size: 1.25rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                font-size: 1.25rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                font-size: 1.25rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                font-size: 1.25rem * $factor-2400;
            }
        }
        .content-featured-person-info {
            color: $color-nochvielvor-black;
            font-size: 1rem;
            line-height: 1.6;
            @media screen and (max-width: 767px) {
                font-size: 1rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                font-size: 1rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                font-size: 1rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                font-size: 1rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                font-size: 1rem * $factor-2400;
            }
            a {
                color: $color-nochvielvor-pink;
            }
            p {
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
        &.isEmpty {
            .teaser {
                margin-top: -1.5rem;
                @media screen and (min-width: 1200px) {
                    margin-top: -1.5rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    margin-top: -1.5rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    margin-top: -1.5rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    margin-top: -1.5rem * $factor-2400;
                }
            }
        }
        &.headerIsDisabled {
            .article-inner {
                padding-top: 8.5rem;
                @media screen and (max-width: 767px) {
                    padding-top: 5.5rem;
                }
                @media screen and (min-width: 1200px) {
                    padding-top: 8.5rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    padding-top: 8.5rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    padding-top: 8.5rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    padding-top: 8.5rem * $factor-2400;
                }
            }
        }
        .table-wrapper {
            max-width: 100%;
            margin: 0 0 1rem 0;
            overflow-x: auto;
            @media screen and (min-width: 1200px) {
                margin: 0 0 1rem * $factor-1200 0;
            }
            @media screen and (min-width: 1440px) {
                margin: 0 0 1rem * $factor-1440 0;
            }
            @media screen and (min-width: 1920px) {
                margin: 0 0 1rem * $factor-1920 0;
            }
            @media screen and (min-width: 2400px) {
                margin: 0 0 1rem * $factor-2400 0;
            }
            table {
                margin: 0;
            }
        }

        .rating-section{
            padding-top: 24px;
            padding-bottom: 24px;
            border-top:2px solid #707070;
            @media screen and (min-width: 768px) {
                padding-top: 35px;
                padding-bottom: 35px;
            }
            @media screen and (min-width: 1200px) {
                padding-top: 28px * $factor-1200;
                padding-bottom: 28px * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                padding-top: 28px * $factor-1440;
                padding-bottom: 28px * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                padding-top: 28px * $factor-1920;
                padding-bottom: 28px * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                padding-top: 28px * $factor-2400;
                padding-bottom: 28px * $factor-2400;
            }
            .article-social{
                margin-bottom: auto;
                margin-top: 5px;
                text-align: left;
                @media screen and (min-width: 768px) {
                    text-align: right;
                    margin-top: 20px;
                }
                .social-icon-listing{
                    margin: 0;
                    padding: 0;
                    li{
                        display: inline-block;
                    }
                    .social-icon-heading{
                        font-size: 14px;
                        font-weight: bold;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 32px;
                        display: block;
                        margin-bottom: 25px;
                        @media screen and (min-width: 768px) {
                            display: inline-block;
                            font-size: 25px;
                            margin-bottom: auto;
                        }
                    }
                    .social-icon-item {
                        display: inline-block;
                        //width: 35px;
                        //height: 35px;
                        text-align: center;
                        img{
                          @media screen and (max-width: 767px) {
                              padding-left: 8px;
                              padding-right: 8px;
                          }
                          @media screen and (min-width: 768px) {
                              padding-left: 12.5px;
                              margin-bottom: 10px;
                          }
                        }
                        @media screen and (max-width: 767px) {
                            margin-left: 10px;
                        }
                        //background: $color-nochvielvor-pink;
                        /* Rotate */
                        /*-webkit-transform: rotate(-45deg);
                        -moz-transform: rotate(-45deg);
                        -ms-transform: rotate(-45deg);
                        -o-transform: rotate(-45deg);
                        transform: rotate(-45deg);*/
                        /* Rotate Origin */
/*                        -webkit-transform-origin: 0 100%;
                        -moz-transform-origin: 0 100%;
                        -ms-transform-origin: 0 100%;
                        -o-transform-origin: 0 100%;
                        transform-origin: 0 100%;*/
                        .article-social-icon{
                            /* Rotate */
                            -webkit-transform: rotate(45deg);
                            -moz-transform: rotate(45deg);
                            -ms-transform: rotate(45deg);
                            -o-transform: rotate(45deg);
                            transform: rotate(45deg);
                            width: auto;
                            height: auto;
                            img{
                                margin-left: 3px;
                                margin-top: 3px;
                                max-width:22px;
                            }
                        }
                    }
                }
            }
        }
        .referenzen-container{
            padding-top: 42px;
            padding-bottom: 42px;
            border-top:2px solid #707070;
            @media screen and (min-width: 768px) {
                padding-top: 80px;
                padding-bottom: 60px;
            }
            .heading{
                font-size: 18px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.2;
                letter-spacing: normal;
                text-align: left;
                color: $color-nochvielvor-black;
                margin-bottom: 13px;
                @media screen and (min-width: 768px) {
                    font-size: 30px;
                    line-height: 1.07;
                    color: #2b2e34;
                    margin-bottom: 37px;
                }
            }
            .referenzen{
                font-size: 9px;
                font-weight: normal;
                font-stretch: normal;
                font-style: italic;
                line-height: 1.6;
                letter-spacing: normal;
                text-align: left;
                color: #2b2e34;
                @media screen and (min-width: 768px) {
                    font-size: 15px;
                    line-height: 1.6;
                }
            }
            .ref-url{
                color:$color-nochvielvor-pink;
                a{
                    color: inherit;
                }
            }
        }
        .image-copyright-text {
            opacity: 0.4;
            font-size: 10px;
            margin: 15px auto 0;
            padding-left: 15px;
            padding-right: 15px;
            text-align: right;
            -moz-user-select: none;
            -webkit-user-select: none;
            -ms-user-select: none;
            -o-user-select: none;
            user-select: none;
            @media (min-width: 768px) {
                font-size: 12px;
            }
        }

        .content-teaser {
          .content-teaser-left {
              background-color: $color-nochvielvor-pink;
                &.bg-black {
                    background-color: $color-nochvielvor-black;
              }
              .content-teaser-left-inner {
                padding: 30px 0 38px;
                @media screen and (min-width: 1200px) {
                  padding: 46px 30px 46px 0;
                }
              }
          }
          .content-teaser-overlay-left {
              background-color: inherit;
              z-index:-1;
              @media screen and (min-width: 992px) {
                  left: calc(-100vw + 100%);
                  width: calc(100vw - 100%);
              }
              @media screen and (max-width: 991.98px) {
                  width: 100vw;
                  margin-left: calc(0px - 50vw + 50%);
              }
          }
          .content-teaser-headline {
            font-size: 25px;
            line-height: 1.17;
            margin-bottom: 15px;
            @media screen and (min-width: 1200px) {
              font-size: 30px;
              margin-bottom: 20px;
            }
          }
          .content-teaser-subheadline {
            font-size: 22px;
            font-weight: 500;
            line-height: 1.05;
            margin-bottom: 20px;
            @media screen and (min-width: 1200px) {
              font-size: 25px;
              font-weight: normal;
              margin-bottom: 25px;
            }
          }
          .content-teaser-text {
            font-size: 18px;
            line-height: 1.56;
            @media screen and (min-width: 1200px) {
              font-size: 22px;
              line-height: 1.27;
            }
          }
          .content-teaser-image {
              background-size: cover;
              background-position: center center;
              background-repeat: no-repeat;
              @media screen and (min-width: 992px) {
                  width: calc(100vw - 100%);
              }
              @media screen and (max-width: 991.98px) {
                  width: 100vw;
                  margin-left: calc(0px - 50vw + 50%);
              }
          }
        }
    }
</style>



// WEBPACK FOOTER //
// public/js/components/Article.vue